import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import { store } from './state/store'
import { BrowserRouter } from 'react-router-dom'
import AppProviders from './providers/AppProviders'
import 'assets/styles/index.css'

import "./i18n"

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
)
root.render(
	//<React.StrictMode>
		<BrowserRouter>
			<Provider store={store}>
				<AppProviders>
					<App />
				</AppProviders>
			</Provider>
		</BrowserRouter>
	//</React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

